import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginPage } from '@/pages/Login';
import { ROUTES } from '@/constants/routes';
import { hasAuthToken } from '@/utils/authGuard';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (typeof window !== 'undefined') {
      if (hasAuthToken()) {
        throw redirect({
          to: ROUTES.ORDER_MANAGEMENT,
          search: {
            page: 1,
            limit: undefined,
            search: undefined,
            status: undefined,
            tab: undefined,
            view: undefined,
          },
        });
      }
    }
  },
  component: LoginPage,
});
